export default (store) => ({
  path : 'manage-users',
    /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
        /*  Webpack - use 'require.ensure' to create a split point
         and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      const ManageUsers = require('./container').default
      cb(null, ManageUsers)
    }, 'manage-users')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ManageUsers/index.js